<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.33301 15.084C8.74711 15.084 9.08283 15.4199 9.08301 15.834C9.08301 16.2482 8.74722 16.584 8.33301 16.584H2.5C2.08579 16.584 1.75 16.2482 1.75 15.834C1.75018 15.4199 2.0859 15.084 2.5 15.084H8.33301Z"
            fill="currentColor"
        />
        <path
            d="M17.5 15.084C17.9139 15.0842 18.2498 15.42 18.25 15.834C18.25 16.2481 17.9141 16.5838 17.5 16.584H11.667C11.2528 16.584 10.917 16.2482 10.917 15.834C10.9172 15.4199 11.2529 15.084 11.667 15.084H17.5Z"
            fill="currentColor"
        />
        <path
            d="M8.33301 11.1953C8.74718 11.1953 9.08294 11.5312 9.08301 11.9453C9.08301 12.3595 8.74722 12.6953 8.33301 12.6953H2.5C2.08579 12.6953 1.75 12.3595 1.75 11.9453C1.75007 11.5312 2.08583 11.1953 2.5 11.1953H8.33301Z"
            fill="currentColor"
        />
        <path
            d="M17.5 11.1953C17.914 11.1955 18.2499 11.5313 18.25 11.9453C18.25 12.3594 17.9141 12.6951 17.5 12.6953H11.667C11.2528 12.6953 10.917 12.3595 10.917 11.9453C10.9171 11.5312 11.2528 11.1953 11.667 11.1953H17.5Z"
            fill="currentColor"
        />
        <path
            d="M17.5 7.30664C17.9141 7.30682 18.25 7.64254 18.25 8.05664C18.2499 8.47069 17.914 8.80646 17.5 8.80664H11.667C11.2528 8.80664 10.9171 8.4708 10.917 8.05664C10.917 7.64243 11.2528 7.30664 11.667 7.30664H17.5Z"
            fill="currentColor"
        />
        <path
            d="M17.5 3.41797C17.9141 3.41815 18.25 3.75387 18.25 4.16797C18.2498 4.58192 17.9139 4.91779 17.5 4.91797H11.667C11.2529 4.91797 10.9172 4.58203 10.917 4.16797C10.917 3.75376 11.2528 3.41797 11.667 3.41797H17.5Z"
            fill="currentColor"
        />
    </svg>
</template>
